module.exports = __webpack_public_path__ + "static/media/photo189.366d5a04.jpg";